/* tslint:disable */
/* eslint-disable */
/**
 * Intee
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLoginModel
 */
export interface UserLoginModel {
    /**
     * 
     * @type {string}
     * @memberof UserLoginModel
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof UserLoginModel
     */
    password: string;
}

export function UserLoginModelFromJSON(json: any): UserLoginModel {
    return UserLoginModelFromJSONTyped(json, false);
}

export function UserLoginModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLoginModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'login': json['login'],
        'password': json['password'],
    };
}

export function UserLoginModelToJSON(value?: UserLoginModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'login': value.login,
        'password': value.password,
    };
}

